module.exports = "/android58e45b5103318d58f4bf99905ab0770f.svg";